<template lang="pug">
  div
    app-plotly(
      v-if="dados.length > 0",
      nomeDiv="DaePeriodo",
      :dados="dados",
      :layout="layout"
    )
</template>
<script>
import AppPlotly from '@/components/AppPlotly'
import _ from 'lodash'

export default {
  components: {
    AppPlotly
  },

  props: {
    daesPeriodo: {
      type: Object,
      default: () => {}
    },
    isMeses: {
      type: Boolean,
      default: true
    },
    filtro: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      layout: {
        barmod: 'group',
        yaxis: {
          title: 'Valor (R$)',
          hoverformat: ',.2f',
          fixedrange: true,
          rangemode: 'tozero'
        },
        hoverlabel: {
          namelength: -1
        },
        separators: ',.',
        bargap: 0.1,
        height: 400,
        margin: {
          l: -5,
          r: -5,
          t: 10,
          b: 90,
          pad: 4
        },
        legend: {
          x: -0.03,
          y: 1.15,
          orientation: 'h'
        },
        xaxis: {
          fixedrange: true
        }
      }
    }
  },

  computed: {
    periodo () {
      const periodo = []

      if (this.filtro.dateRange[0] === undefined && this.filtro.dateRange[1] === undefined) return []

      let mes = this.filtro.dateRange[0].getMonth()
      let ano = this.filtro.dateRange[0].getUTCFullYear()

      const mesFinal = this.filtro.dateRange[1].getMonth()
      const anoFinal = this.filtro.dateRange[1].getUTCFullYear()
      let label = ''

      if (this.isMeses) {
        periodo.push(`${mes + 1 < 10 ? '0' : ''}${mes + 1}/${ano}`)
        while (!(mes === mesFinal && ano === anoFinal)) {
          if (mes === 11) {
            mes = 0
            ano++
          } else {
            mes++
          }

          label = `${mes + 1 < 10 ? '0' : ''}${mes + 1}/${ano}`
          periodo.push(label)
        }
      } else {
        let dia = this.filtro.dateRange[0].getDate()
        const diaFinal = this.filtro.dateRange[1].getDate()

        periodo.push(`${dia < 10 ? '0' : ''}${dia}/${mes + 1 < 10 ? '0' : ''}${mes + 1}/${ano}`)

        while (!(dia === diaFinal && mes === mesFinal && ano === anoFinal)) {
          if (this.daysInMonth(mes, ano) === dia) {
            dia = 1
            if (mes === 11) {
              mes = 0
              ano++
            } else {
              mes++
            }
          } else {
            dia++
          }

          label = `${dia < 10 ? '0' : ''}${dia}/${mes + 1 < 10 ? '0' : ''}${mes + 1}/${ano}`
          periodo.push(label)
        }
      }
      return periodo
    },

    dados () {
      const emptyArray = new Array(this.periodo.length).fill(0)

      if (
        _.isEmpty(this.daesPeriodo.graficoPeriodoEmitido) &&
        _.isEmpty(this.daesPeriodo.graficoPeriodoRecebido) &&
        _.isEmpty(this.daesPeriodo.graficoPeriodoAguardandoPagamento) &&
        _.isEmpty(this.daesPeriodo.graficoPeriodoVencido)
      ) {
        return []
      }

      const emitidos = {
        x: this.periodo,
        y: _.cloneDeep(emptyArray),
        name: 'DAEs emitidos',
        hovertemplate: 'R$ %{y}',
        type: 'scatter',
        marker: {
          color: '#F1C40F'
        }
      }

      const recebidos = {
        x: this.periodo,
        y: _.cloneDeep(emptyArray),
        name: 'DAEs recebidos',
        hovertemplate: 'R$ %{y}',
        type: 'scatter',
        marker: {
          color: '#1ABC9C'
        }
      }

      const aguardandoPagamento = {
        x: this.periodo,
        y: _.cloneDeep(emptyArray),
        name: 'DAEs aguardando pagamento',
        hovertemplate: 'R$ %{y}',
        type: 'scatter',
        marker: {
          color: '#3498DB'
        }
      }

      const vencidos = {
        x: this.periodo,
        y: _.cloneDeep(emptyArray),
        name: 'DAEs vencidos',
        hovertemplate: 'R$ %{y}',
        type: 'scatter',
        marker: {
          color: '#E74C3C'
        }
      }

      if (this.daesPeriodo.graficoPeriodoEmitido && this.daesPeriodo.graficoPeriodoEmitido.length > 0) {
        this.daesPeriodo.graficoPeriodoEmitido.forEach((item) => {
          const index = this.periodo.findIndex(label => item.label === label)
          if (index >= 0) {
            emitidos.y[index] = item.valor
          }
        })
      }

      if (this.daesPeriodo.graficoPeriodoRecebido && this.daesPeriodo.graficoPeriodoRecebido.length > 0) {
        this.daesPeriodo.graficoPeriodoRecebido.forEach((item) => {
          const index = this.periodo.findIndex(label => item.label === label)
          recebidos.y[index] = item.valor
        })
      }

      if (this.daesPeriodo.graficoPeriodoAguardandoPagamento && this.daesPeriodo.graficoPeriodoAguardandoPagamento.length > 0) {
        this.daesPeriodo.graficoPeriodoAguardandoPagamento.forEach((item) => {
          const index = this.periodo.findIndex(label => item.label === label)
          aguardandoPagamento.y[index] = item.valor
        })
      }

      if (this.daesPeriodo.graficoPeriodoVencido && this.daesPeriodo.graficoPeriodoVencido.length > 0) {
        this.daesPeriodo.graficoPeriodoVencido.forEach((item) => {
          const index = this.periodo.findIndex(label => item.label === label)
          vencidos.y[index] = item.valor
        })
      }
      return [emitidos, recebidos, aguardandoPagamento, vencidos]
    }
  },

  methods: {
    daysInMonth (month, year) {
      return new Date(year, month + 1, 0).getDate()
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/screens/financeiro/relatoriosDae/components/GraficoDaesPeriodo.vue